var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-30" },
    [
      _c(
        "md-card",
        { staticClass: "mt-20" },
        [
          _c("md-card-header", [
            _c("div", { staticClass: "md-title card-header" }, [
              _vm._v("Which give should be included?")
            ])
          ]),
          _vm._v(" "),
          _c(
            "md-card-content",
            _vm._l(_vm.ask.gives, function(give, index) {
              return _c("div", { key: index }, [
                _c("table", [
                  _c("tr", [
                    _c(
                      "td",
                      [
                        index != _vm.selected
                          ? _c("font-awesome-icon", {
                              staticClass: "selector",
                              attrs: { icon: "square" },
                              on: {
                                click: function($event) {
                                  return _vm.toggle(index)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        index == _vm.selected
                          ? _c("font-awesome-icon", {
                              staticClass: "selector",
                              attrs: { icon: "check-square" },
                              on: {
                                click: function($event) {
                                  return _vm.toggle(index)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "action" }, [
                      _vm._v("\n\t\t\t\t\t\t\tAction: "),
                      _c("b", [_vm._v(_vm._s(give.action))]),
                      _vm._v(",\n\t\t\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("i", [
                        _vm._v(
                          _vm._s(
                            give.emailSent ? "Already sent" : "Not yet sent"
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "insight" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(give.insight) +
                          "\n\t\t\t\t\t\t"
                      )
                    ])
                  ])
                ])
              ])
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30" },
        [
          _c("md-card-header", [
            _c("div", { staticClass: "md-title card-header" }, [
              _vm._v("Preview connect email for: "),
              _c("b", [_vm._v(_vm._s(_vm.ask.subject))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "md-card-content",
            [
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _vm._v(
                      "\n\t\t\t\t\tSubject: " +
                        _vm._s(_vm.email.subject) +
                        "\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-content",
                    [
                      _c(
                        "md-tabs",
                        [
                          _c(
                            "md-tab",
                            { attrs: { id: "tab-html", "md-label": "HTML" } },
                            [
                              _c("div", { attrs: { id: "previewHTML" } }, [
                                _vm._v("HTML preview...")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-tab",
                            { attrs: { id: "tab-text", "md-label": "Text" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-preview",
                                  attrs: { id: "previewText" }
                                },
                                [_vm._v("Text preview...")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-tab",
                            {
                              attrs: {
                                id: "tab-attachments",
                                "md-label": "Attachments"
                              }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { id: "previewAttachments" } },
                                [_c("i", [_vm._v("(none)")])]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _vm._v(" "),
              _c(
                "base-interaction-button",
                {
                  attrs: { interaction: _vm.action },
                  on: { interact: _vm.doInteraction }
                },
                [_vm._v(_vm._s(_vm.action))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ask-feedback", { staticClass: "mt-30", attrs: { ask: _vm.ask } }, [
        _vm._v("Feedback goes here...")
      ]),
      _vm._v(" "),
      _c(
        "comments",
        { staticClass: "mt-30", attrs: { ask: _vm.ask, section: "Comments" } },
        [_vm._v("Activity log goes here...")]
      ),
      _vm._v(" "),
      _c("activity-log", { staticClass: "mt-30", attrs: { ask: _vm.ask } }, [
        _vm._v("Activity log goes here...")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ca7951e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca7951e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InteractRequestFeedback.vue
// module id = null
// module chunks = 